module.exports = __webpack_public_path__ + "static/media/ahcene_bounceur.986f06c5.png";